import { DefaultApi, createApiInstance } from '@geckoal/gecko-api-client'
import { getAccessTokenSilentlyOutsideComponent } from '@/lib/auth'
import { PreferredUnits, type PreferredUnitsData } from '@geckoal/theme-bundle'

let _api: DefaultApi | undefined = undefined

const appVersion = (globalThis.location?.hostname || 'admin').substring(0, 12)

export const useApi = ({ rebuild = false } = {}): DefaultApi => {
    if (_api && !rebuild) return _api
    _api = createApiInstance({
        baseUrl: import.meta.env.VITE_CRYSTAL_API_BASE_URL,
        authToken: async (name?: string) => {
            if (name === 'auth0Bearer') {
                const token = await getAccessTokenSilentlyOutsideComponent()
                return token
            }
        },
        platform: 'web',
        appVersion,
        timeoutMs: 28000, // longer for admin so raw charts have to time to return
        localeCode: 'en' // until admin is localized, use english only (otherwise users see a weird mashup of languages)
    })
    return _api
}

/** Returns an api instance that will set the provided units in the http headers */
export const useApiWithUnits = (units: Partial<PreferredUnitsData>): DefaultApi => {
    const encodedUnits = new PreferredUnits(units).encode()

    return createApiInstance({
        baseUrl: import.meta.env.VITE_CRYSTAL_API_BASE_URL,
        authToken: async (name?: string) => {
            if (name === 'auth0Bearer') {
                const token = await getAccessTokenSilentlyOutsideComponent()
                return token
            }
        },
        platform: 'web',
        appVersion,
        timeoutMs: 28000, // longer for admin so raw charts have to time to return
        localeCode: 'en', // until admin is localized, use english only (otherwise users see a weird mashup of languages)
        encodedUnits
    })
}
